import { gql } from "@apollo/client";

export const SEARCH_DB = gql`
  query SearchDb($q: String, $filter: FilterInput) {
    searchDb(q: $q, filter: $filter) {
      title
      type
      reason
      q
      score
      snippet
      sourceLabel
    }
  }
`;

export const SEARCH_VEC = gql`
  query SearchVec($q: String) {
    searchVec(q: $q) {
      title
      type
      reason
      q
      score
      snippet
      sourceLabel
    }
  }
`;

export const GET_ITEM = gql`
  query GetItem($q: String!) {
    getItem(q: $q) {
      title
      description
      species {
        name
        description
        q
      }
      commonNames {
        id
        name
        q
      }
      metabolites {
        q
        name
        description
        relevance{
          level
          description
          hexColor
        }
        assessments {
          id
          status
          context
          comment
          dimension {
            code
            name
            description
            hexColor
            framework {
              code
              name
              description
              hexColor
            }
          }
          value {
            code
            label
            description
            hexColor
            rank
          }
          sourceDocument {
            id
            title
            sourceUrl
            publisher
            publicationYear
          }
        }
      }
      therapeuticEffects{
        q
        term
        meaning
        comment
        relevance {
          level
          description
          hexColor
        }
        assessments {
          id
          status
          context
          comment
          dimension {
            code
            name
            description
            hexColor
            framework {
              code
              name
              description
              hexColor
            }
          }
          value {
            code
            label
            description
            hexColor
            rank
          }
          sourceDocument {
            id
            title
            sourceUrl
            publisher
            publicationYear
          }
        }
      }
      prescriptionSuggestions {
        specie {
          name
        }
        part {
          name
        }
        dosage
        quantity
        description
      }
      categories {
        name
      }
      family
      synonyms
      pharmaceuticalProducts {
        id
        commercialName
        substance
        pharmaceuticalForm {
          id
          name
        }
        presentations {
          id
          concentration
          quantity
        }
        metadata
      }
      references {
        id
        title
        authors
        journal
        year
        doi
      }
    }
  }
`;

export const GET_SPECIES = gql`
  query Species {
    species {
      id
      name
      description
    }
  }
`;

export const GET_SPECIE = gql`
  query Specie($id: Int!) {
  specie(id: $id) {
    id
    name
    fullySpecifiedName
    description
    commonNames {
      id
      name
      q
      nameType
    }
    metabolites{
      id
      name
      description
    }
    metabolitesRelevance{
      metabolite{
        id
        name
        description
      }
      relevance{
        level
        hexColor
      }
    }
    prescriptions{
      part{
        id
        name
        description
      }
      id
      dosage
      description
    }
    therapeuticEffects{
      id
      term
      meaning
    }
    therapeuticEffectsRelevance{
      comment
      therapeuticEffect{
        id
        term
        meaning
      }
      relevance{
        level
        hexColor
      }
    }
  }
}
`;

export const GET_COMMON_NAMES = gql`
  query CommonNames {
    commonNames {
      id
      name
      q
      nameType
    }
  }
`;

export const GET_THERAPEUTIC_EFFECTS = gql`
  query TherapeuticEffects {
    therapeuticEffects {
      id
      term
      meaning
    }
  }
`;

export const GET_METABOLITES = gql`
  query Metabolites {
    metabolites {
      id
      name
      description
    }
  }
`;

export const GET_RELEVANCE = gql`
  query Relevance {
    relevance {
      level
      description
      hexColor
    }
  }
`;

export const GET_PLANT_PARTS = gql`
  query PlantParts {
    plantParts {
      id
      name
      description
    }
  }
`;

export const GET_CATEGORIES = gql`
  query Categories {
    categories {
      id
      name
    }
  }
`;

export const UPDATE_SPECIE = gql`
  mutation UpdateSpecie($id: Int!, $fullySpecifiedName: String!, $description: String, $commonNames: [CommonNameInput], $therapeuticEffects: [TherapeuticEffectInput], $metabolites: [MetaboliteInput], $prescriptionSuggestions: [PrescriptionSuggestionInput]) {
    updateSpecie(id: $id, fullySpecifiedName: $fullySpecifiedName, description: $description, commonNames: $commonNames, therapeuticEffects: $therapeuticEffects, metabolites: $metabolites, prescriptionSuggestions: $prescriptionSuggestions) {
      id
    }
  }
`;

export const CREATE_SPECIE = gql`
  mutation CreateSpecie($fullySpecifiedName: String!) {
    createSpecie(fullySpecifiedName: $fullySpecifiedName) {
      id
    }
  }
  `
